module.exports = __webpack_public_path__ + "img/p-one-step-18.32e0530e.png";